import React from 'react'

const TypingLoader_cust = () => {
  return (
    <>
      <div className="typing-loader">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
    </div>
    </>
  )
}

export default TypingLoader_cust
